<template>
  <div>
    <v-list outlined rounded dense>
      <v-list-item-group color="primary">
        <v-list-item
          class="ma-0"
          v-for="(team, index) in teams"
          :key="team.name + index"
        >
          <v-list-item-icon class="ma-0 mt-3 me-3">
            <v-icon
              color="blue lighten-1"
              :style="team.site !== null ? 'visibility: hidden' : ''"
              >mdi-web</v-icon
            >
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <text-highlight
                highlightClass="yellow lighten-1"
                data-private
                highlightComponent="span"
                :queries="highlightTerm"
              >
                {{ team.name }}
              </text-highlight>
            </v-list-item-title>
            <v-list-item-subtitle
              v-text="
                $t('teams.memberWithCount', { count: team.members.length })
              "
            >
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <Button
              small
              icon="mdi-pencil-outline"
              color="blueGrey"
              data-testid="teams-icon-edit"
              @click="$emit('edit', team)"
            />

            <Button
              small
              icon="mdi-delete-outline"
              color="blueGrey"
              data-testid="teams-icon-delete"
              @click="onDelete(team)"
            />
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <DeleteConfirmationModal
      :show="showDeleteModal"
      :isLoading="isDeleting"
      :title="$t('teams.delete_title')"
      :text="$t('teams.delete_confirmation')"
      @cancel="showDeleteModal = false"
      @delete="deleteTeam"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import mixin from '@/mixins/mixin.vue'

import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'TeamsList',

  mixins: [mixin],

  components: {
    DeleteConfirmationModal,
    Button,
  },

  props: {
    highlightTerm: {
      type: String,
      default: '',
    },
    teams: {
      type: Array,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showDeleteModal: false,
      isDeleting: false,
      showMembersModal: false,
      showChangesModal: false,
      showEditModal: false,
      isSavingMembers: false,
      teamToDelete: {},
      activeTeam: {},
      originalTeam: {},
    }
  },

  computed: {
    ...mapGetters(['accountId']),

    hasChanges: {
      cache: false,
      get() {
        return !_.isEqual(this.activeTeam, this.originalTeam)
      },
    },
  },

  methods: {
    ...mapActions({
      delete: 'teams/deleteTeam',
      updateMembers: 'teams/updateMembers',
    }),

    onDelete(team) {
      this.showDeleteModal = true
      this.teamToDelete = team
    },

    async deleteTeam() {
      try {
        this.isDeleting = true
        await this.delete({
          organizationId: this.organizationId,
          teamId: this.teamToDelete.id,
        })
        this.$emit('change')
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.isDeleting = false
        this.showDeleteModal = false
      }
    },
  },
}
</script>
